//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GQL from './gql'
import GridView from '@/components/GridView'
import GridViewLabel from '@/components/GridViewLabel'
import GridViewValue from '@/components/GridViewValue'

export default {
  components: {
    GridView,
    GridViewLabel,
    GridViewValue
  },

  apollo: {
    service: GQL.service
  },

  data() {
    return {
      service: {}
    }
  },

  computed: {
    mapLink() {
      return this.service?.location?.premise?.map_link
    },

    premiseId() {
      let premise_id = this.service?.location?.premise.id || '--'
      if (premise_id !== '--') {
        premise_id = 'PREM#' + premise_id
      }
      return premise_id
    },

    locationId() {
      let location_id = this.service?.location?.id || '--'
      if (location_id !== '--') {
        location_id = 'LOC' + location_id
      }
      return location_id
    },

    customerServiceName() {
      return this.service?.location?.premise?.customer_name || '--'
    },

    address() {
      return this.service?.location?.premise?.address || '--'
    },

    customerName() {
      const firstName = this.service?.location?.first_name
      const lastName = this.service?.location?.last_name
      let output = firstName

      if (lastName) {
        output += ` ${lastName}`
      }

      return output
    },

    customerContactNumber() {
      return this.service?.location?.order_contact_number || '--'
    }
  }
}
